import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Users, ArrowDownToLine, Clock,
  ArrowUpFromLine, Target, List, Gamepad2, UserPlus,
  UsersRound, Wallet, TrendingUp, CreditCard, Receipt,
  Handshake, History, ArrowLeftRight, Star, Sparkles, BookmarkPlus,
  BarChart3, ArrowRightLeft, Image as ImageIcon, Bell, BellRing,
  MessageSquare, MessageCircle, Mail, User, KeyRound,
  SlidersHorizontal, ShieldAlert, FileText, PhoneCall, Globe,
  ShieldCheck, Gift, Crown, ArrowDownToLine as DownloadIcon, Megaphone, Plug, LayoutGrid, Award, Layers, X, Database, Smartphone, Send, Network, Coins, BookOpen, UserCog, Wrench, Radio, GitBranch, Calendar, Settings, AlertTriangle, Dices,
} from "lucide-react";

const groups = [
  {
    label: null,
    items: [
      { to: "/root/admin/dashboard", icon: LayoutDashboard, label: "Dashboard", testId: "nav-dashboard" },
      { to: "/root/admin/reports", icon: BarChart3, label: "Reports & Analytics", testId: "nav-reports" },
    ],
  },
  {
    label: "Player",
    items: [
      { to: "/root/admin/players", icon: Users, label: "Player Management", testId: "nav-players" },
      { to: "/root/admin/kyc-review", icon: ShieldCheck, label: "KYC Review", testId: "nav-kyc-review" },
      { to: "/root/admin/anti-fraud", icon: ShieldAlert, label: "Anti-Fraud", testId: "nav-anti-fraud" },
      { to: "/root/admin/turnover", icon: TrendingUp, label: "Turnover Management", testId: "nav-turnover" },
      { to: "/root/admin/referrals", icon: Network, label: "Referral Network", testId: "nav-referrals" },
      { to: "/root/admin/commission-settings", icon: Coins, label: "Commission Settings", testId: "nav-commission-settings" },
    ],
  },
  {
    label: "Deposit",
    items: [
      { to: "/root/admin/deposits/all", icon: ArrowDownToLine, label: "All Deposit", testId: "nav-deposits-all" },
      { to: "/root/admin/deposits/pending", icon: Clock, label: "Pending Deposit", testId: "nav-deposits-pending" },
    ],
  },
  {
    label: "Withdraw",
    items: [
      { to: "/root/admin/withdraws/all", icon: ArrowUpFromLine, label: "All Withdraw", testId: "nav-withdraws-all" },
      { to: "/root/admin/withdraws/pending", icon: Clock, label: "Pending Withdraw", testId: "nav-withdraws-pending" },
    ],
  },
  {
    label: "Transactions",
    items: [
      { to: "/root/admin/transactions", icon: ArrowRightLeft, label: "All Transactions", testId: "nav-transactions" },
    ],
  },
  {
    label: "Bets",
    items: [
      { to: "/root/admin/bets/pending", icon: Target, label: "Pending Bet", testId: "nav-bets-pending" },
      { to: "/root/admin/bets/stuck", icon: AlertTriangle, label: "Stuck Bets", testId: "nav-bets-stuck" },
      { to: "/root/admin/bets/list", icon: List, label: "Bet List", testId: "nav-bets-list" },
      { to: "/root/admin/bets/aviator-cancels", icon: Radio, label: "Aviator Cancels", testId: "nav-aviator-cancels" },
      { to: "/root/admin/bets/games", icon: Gamepad2, label: "Games", testId: "nav-games" },
      { to: "/root/admin/bets/providers", icon: Plug, label: "Providers", testId: "nav-providers" },
      { to: "/root/admin/lottery", icon: Dices, label: "Lottery Games", testId: "nav-lottery" },
      { to: "/root/admin/config/home-shelves", icon: LayoutGrid, label: "Home Shelves", testId: "nav-home-shelves" },
    ],
  },
  {
    label: "Agent",
    items: [
      { to: "/root/admin/agents/create", icon: UserPlus, label: "Create Agent", testId: "nav-agent-create" },
      { to: "/root/admin/agents/applications", icon: Handshake, label: "Agent Applications", testId: "nav-agent-applications" },
      { to: "/root/admin/agents/list", icon: UsersRound, label: "Agent List", testId: "nav-agent-list" },
      { to: "/root/admin/agents/self-deposit-dashboard", icon: BarChart3, label: "Self-Deposit Dashboard", testId: "nav-agent-self-deposit-dashboard" },
      { to: "/root/admin/agents/pre-payment", icon: Wallet, label: "Pre Payment", testId: "nav-prepayment" },
      { to: "/root/admin/agents/commission", icon: TrendingUp, label: "Commission", testId: "nav-commission" },
      { to: "/root/admin/agents/monthly-commission-run", icon: Coins, label: "Monthly Commission Run", testId: "nav-monthly-commission-run" },
      { to: "/root/admin/agents/usdt-deposits", icon: ArrowDownToLine, label: "USDT Deposits", testId: "nav-agent-usdt-deposits" },
      { to: "/root/admin/agents/bdt-deposits", icon: ArrowDownToLine, label: "BDT Deposits", testId: "nav-agent-bdt-deposits" },
      { to: "/root/admin/agents/deposit-bonus", icon: Gift, label: "Deposit Bonus", testId: "nav-agent-deposit-bonus" },
      { to: "/root/admin/agents/guideline", icon: BookOpen, label: "Operating Handbook", testId: "nav-agent-guideline" },
    ],
  },
  {
    label: "Agent Deposit",
    items: [
      { to: "/root/admin/agents/deposits/all", icon: ArrowDownToLine, label: "All Deposit", testId: "nav-agent-deposits-all" },
      { to: "/root/admin/agents/deposits/pending", icon: Clock, label: "Pending Deposit", testId: "nav-agent-deposits-pending" },
    ],
  },
  {
    label: "Agent Withdraw",
    items: [
      { to: "/root/admin/agents/withdraws/all", icon: ArrowUpFromLine, label: "All Withdraw", testId: "nav-agent-withdraws-all" },
      { to: "/root/admin/agents/withdraws/pending", icon: Clock, label: "Pending Withdraw", testId: "nav-agent-withdraws-pending" },
    ],
  },
  {
    label: "Payment Method",
    items: [
      { to: "/root/admin/payment/create", icon: CreditCard, label: "Create Payment", testId: "nav-payment-create" },
      { to: "/root/admin/payment/list", icon: Receipt, label: "Payments List", testId: "nav-payment-list" },
      { to: "/root/admin/payment/gateways", icon: CreditCard, label: "Gateways", testId: "nav-gateways" },
    ],
  },
  {
    label: "Affiliate",
    items: [
      { to: "/root/admin/affiliate/overview", icon: BarChart3, label: "Affiliate Overview", testId: "nav-affiliate-overview" },
      { to: "/root/admin/affiliate/cycles", icon: Calendar, label: "Calendar Cycles · Safe", testId: "nav-affiliate-cycles" },
      { to: "/root/admin/affiliate/safe-config", icon: Settings, label: "Safe Formula Config", testId: "nav-affiliate-safe-config" },
      { to: "/root/admin/affiliate/deficits", icon: AlertTriangle, label: "Deficit Tracker", testId: "nav-affiliate-deficits" },
      { to: "/root/admin/affiliate/program", icon: Award, label: "Affiliate Program", testId: "nav-affiliate-program" },
      { to: "/root/admin/affiliate/campaigns", icon: Megaphone, label: "Campaigns", testId: "nav-affiliate-campaigns" },
      { to: "/root/admin/affiliate/withdraw", icon: Wallet, label: "Affiliate Withdraw", testId: "nav-affiliate-withdraw" },
      { to: "/root/admin/affiliate/accounts", icon: KeyRound, label: "Panel Accounts", testId: "nav-affiliate-accounts" },
      { to: "/root/admin/affiliate/settlements", icon: Wallet, label: "Commission Settlements", testId: "nav-affiliate-settlements" },
      { to: "/root/admin/affiliate/analytics", icon: BarChart3, label: "Analytics", testId: "nav-affiliate-analytics" },
      { to: "/root/admin/affiliate/funnel", icon: BarChart3, label: "Conversion Funnel", testId: "nav-affiliate-funnel" },
      { to: "/root/admin/affiliate/fraud", icon: Star, label: "Fraud Protection", testId: "nav-affiliate-fraud" },
      { to: "/root/admin/affiliate/sub-tree", icon: GitBranch, label: "Sub-Affiliate Tree", testId: "nav-affiliate-sub-tree" },
      { to: "/root/admin/affiliate/payout-config", icon: SlidersHorizontal, label: "Payout Config", testId: "nav-affiliate-payout-config" },
      { to: "/root/admin/affiliate/announcements", icon: Megaphone, label: "Announcements", testId: "nav-affiliate-announcements" },
      { to: "/root/admin/affiliate/tiers", icon: Crown, label: "Commission Tiers", testId: "nav-affiliate-tiers" },
      { to: "/root/admin/affiliate/contests", icon: Star, label: "Contests", testId: "nav-affiliate-contests" },
      { to: "/root/admin/affiliate/tickets", icon: MessageSquare, label: "Support Tickets", testId: "nav-affiliate-tickets" },
      { to: "/root/admin/affiliate/broadcast", icon: Send, label: "Broadcast", testId: "nav-affiliate-broadcast" },
      { to: "/root/admin/affiliate/audit", icon: FileText, label: "Audit Log", testId: "nav-affiliate-audit" },
      { to: "/root/admin/affiliate/reports", icon: DownloadIcon, label: "Reports & Export", testId: "nav-affiliate-reports" },
      { to: "/root/admin/affiliate/list", icon: Handshake, label: "Affiliate List", testId: "nav-affiliate-list" },
      { to: "/root/admin/affiliate/history", icon: History, label: "History", testId: "nav-affiliate-history" },
      { to: "/root/admin/affiliate/transfer", icon: ArrowLeftRight, label: "Transfer", testId: "nav-affiliate-transfer" },
      { to: "/root/admin/affiliate/review", icon: Star, label: "Review", testId: "nav-affiliate-review" },
    ],
  },
  {
    label: "Marketing",
    items: [
      { to: "/root/admin/categories", icon: LayoutGrid, label: "Site Categories", testId: "nav-categories" },
      { to: "/root/admin/banners", icon: ImageIcon, label: "Banners", testId: "nav-banners" },
      { to: "/root/admin/auth-banners", icon: ImageIcon, label: "Login Banners", testId: "nav-auth-banners" },
      { to: "/root/admin/popups", icon: Layers, label: "Site Popups", testId: "nav-popups" },
      { to: "/root/admin/popular/add", icon: BookmarkPlus, label: "Add Popular", testId: "nav-popular-add" },
      { to: "/root/admin/popular/list", icon: Sparkles, label: "Popular List", testId: "nav-popular-list" },
      { to: "/root/admin/promotions", icon: Gift, label: "Promotions", testId: "nav-promotions" },
      { to: "/root/admin/free-spin", icon: Sparkles, label: "Daily Free Spin", testId: "nav-free-spin" },
      { to: "/root/admin/vip-dashboard", icon: Crown, label: "VIP Dashboard", testId: "nav-vip-dashboard" },
      { to: "/root/admin/vip-tiers", icon: Crown, label: "VIP Tiers", testId: "nav-vip-tiers" },
    ],
  },
  {
    label: "Communication",
    items: [
      { to: "/root/admin/notifications", icon: Bell, label: "Notifications", testId: "nav-notifications" },
      { to: "/root/admin/live-chat", icon: MessageSquare, label: "Live Chat", testId: "nav-live-chat" },
      { to: "/root/admin/live-support-agents", icon: MessageSquare, label: "Live Support Agents", testId: "nav-live-support-agents" },
      { to: "/root/admin/live-support-topics", icon: MessageSquare, label: "Live Support Topics", testId: "nav-live-support-topics" },
      { to: "/root/admin/live-support-forms", icon: MessageSquare, label: "Live Support Forms", testId: "nav-live-support-forms" },
      { to: "/root/admin/live-support-submissions", icon: MessageSquare, label: "Live Support Submissions", testId: "nav-live-support-submissions" },
      { to: "/root/admin/live-support-agent-performance", icon: MessageSquare, label: "Agent Performance", testId: "nav-live-support-agent-performance" },
      { to: "/root/admin/live-support-quick-replies", icon: MessageSquare, label: "Quick Replies", testId: "nav-live-support-quick-replies" },
      { to: "/root/admin/live-support-chat-templates", icon: MessageSquare, label: "Chat Templates", testId: "nav-live-support-chat-templates" },
      { to: "/root/admin/live-support-performance", icon: MessageSquare, label: "Live Support Performance", testId: "nav-live-support-performance" },
      { to: "/root/admin/support", icon: MessageSquare, label: "Support Tickets", testId: "nav-support" },
    ],
  },
  {
    label: "Configuration",
    items: [
      { to: "/root/admin/configuration/general", icon: SlidersHorizontal, label: "General", testId: "nav-cfg-general" },
      { to: "/root/admin/configuration/logo", icon: ImageIcon, label: "Logo & Icon", testId: "nav-cfg-logo" },
      { to: "/root/admin/configuration/home-content", icon: LayoutGrid, label: "Home Content", testId: "nav-cfg-home-content" },
      { to: "/root/admin/configuration/risk", icon: ShieldAlert, label: "Risk Management", testId: "nav-cfg-risk" },
      { to: "/root/admin/configuration/deposit", icon: DownloadIcon, label: "Deposit Config", testId: "nav-cfg-deposit" },
      { to: "/root/admin/configuration/usdt-deposit", icon: DownloadIcon, label: "USDT Deposit (Agent)", testId: "nav-cfg-usdt-deposit" },
      { to: "/root/admin/configuration/agent-bdt-deposit", icon: DownloadIcon, label: "BDT Deposit (Agent)", testId: "nav-cfg-agent-bdt-deposit" },
      { to: "/root/admin/configuration/crypto", icon: DownloadIcon, label: "Crypto (Site)", testId: "nav-cfg-crypto" },
      { to: "/root/admin/configuration/withdraw", icon: Wallet, label: "Withdraw Config", testId: "nav-cfg-withdraw" },
      { to: "/root/admin/configuration/announcements", icon: Megaphone, label: "Announcements", testId: "nav-cfg-announcements" },
      { to: "/root/admin/configuration/site-notice", icon: Wrench, label: "Site Notice", testId: "nav-cfg-site-notice" },
      { to: "/root/admin/configuration/live-chat", icon: MessageCircle, label: "Live Chat Widget", testId: "nav-cfg-live-chat" },
      { to: "/root/admin/configuration/telegram-support", icon: Send, label: "Telegram Support", testId: "nav-cfg-telegram-support" },
      { to: "/root/admin/configuration/dst", icon: Plug, label: "DST Gaming API", testId: "nav-cfg-dst" },
      { to: "/root/admin/configuration/apk", icon: Smartphone, label: "APK Downloads", testId: "nav-cfg-apk" },
      { to: "/root/admin/configuration/telegram", icon: Send, label: "Telegram Bots", testId: "nav-cfg-telegram" },
      { to: "/root/admin/configuration/meta", icon: FileText, label: "Meta Data", testId: "nav-cfg-meta" },
      { to: "/root/admin/configuration/contact", icon: PhoneCall, label: "Contact", testId: "nav-cfg-contact" },
      { to: "/root/admin/configuration/social", icon: Globe, label: "Social", testId: "nav-cfg-social" },
      { to: "/root/admin/system/monthly-reset", icon: Database, label: "Monthly Auto-Reset", testId: "nav-monthly-reset" },
    ],
  },
  {
    label: "Gateway",
    items: [
      { to: "/root/admin/settings/sms", icon: MessageCircle, label: "SMS Gateway", testId: "nav-sms" },
      { to: "/root/admin/settings/email", icon: Mail, label: "Email Gateway", testId: "nav-email" },
      { to: "/root/admin/settings/notification-email", icon: BellRing, label: "Notification Email", testId: "nav-notification-email" },
      { to: "/root/admin/settings/agent-email", icon: UserCog, label: "Agent Email Gateway", testId: "nav-agent-email" },
      { to: "/root/admin/settings/affiliate-email", icon: Users, label: "Affiliate Email Gateway", testId: "nav-affiliate-email" },
    ],
  },
  {
    label: "Access Control",
    items: [
      { to: "/root/admin/admin-users", icon: ShieldCheck, label: "Admin Users", testId: "nav-admin-users" },
    ],
  },
  {
    label: "Account",
    items: [
      { to: "/root/admin/profile", icon: User, label: "Profile", testId: "nav-profile" },
      { to: "/root/admin/change-password", icon: KeyRound, label: "Change Password", testId: "nav-password" },
      { to: "/root/admin/two-factor", icon: ShieldCheck, label: "Two-Factor Auth", testId: "nav-two-factor" },
    ],
  },
];

export default function Sidebar({ collapsed, mobileOpen = false, onCloseMobile }) {
  return (
    <>
      {/* Mobile backdrop — tap to close */}
      <div
        onClick={onCloseMobile}
        className={`lg:hidden fixed inset-0 bg-black/60 backdrop-blur-sm z-40 transition-opacity duration-200 ${
          mobileOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        data-testid="sidebar-backdrop"
        aria-hidden={!mobileOpen}
      />

      <aside
        className={[
          // Mobile: fixed drawer, slides from left
          "fixed lg:sticky top-0 left-0 z-50 h-screen flex flex-col flex-shrink-0",
          "bg-[#09090B] border-r border-[#27272A]",
          "transition-transform duration-200 lg:transition-all",
          // Width handling
          "w-72",
          collapsed ? "lg:w-0 lg:overflow-hidden" : "lg:w-64",
          // Slide on mobile
          mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0",
        ].join(" ")}
        data-testid="sidebar"
      >
        <div className="h-16 flex items-center justify-between gap-2 px-5 border-b border-[#27272A]">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-sm bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center font-display font-bold text-white shadow-md shadow-red-900/30">
              M
            </div>
            <div className="leading-tight">
              <div className="text-white font-display font-bold text-[15px]">Maxlive88</div>
              <div className="text-[10px] uppercase tracking-wider text-zinc-500">Admin Console</div>
            </div>
          </div>
          {/* Mobile close button */}
          <button
            type="button"
            onClick={onCloseMobile}
            className="lg:hidden h-8 w-8 flex items-center justify-center rounded-sm text-zinc-400 hover:text-white hover:bg-white/5"
            aria-label="Close menu"
            data-testid="sidebar-close-mobile"
          >
            <X size={18} />
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto sidebar-scroll py-3">
          {groups.map((g, gi) => (
            <div key={gi}>
              {g.label && <div className="sidebar-section">{g.label}</div>}
              {g.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  data-testid={item.testId}
                  className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                >
                  <item.icon size={16} strokeWidth={1.75} />
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="px-4 py-3 border-t border-[#27272A] text-[10px] uppercase tracking-wider text-zinc-500 flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 bg-emerald-500 rounded-full animate-pulse" />
          <span className="text-emerald-400">Connected to Site DB</span>
        </div>
      </aside>
    </>
  );
}
